module.exports = __webpack_public_path__ + "static/columns-073854a6b654c805e634ed19921def0d.png";